import React, { createContext, useState } from 'react';

// Define the shape of the app state
interface AppState {
  user: string;
  isAuthenticated: boolean;
}

// Create a context for the app state with a default value
export const AppStateContext = createContext<{
  state: AppState;
  setState: React.Dispatch<React.SetStateAction<AppState>>;
}>({
  state: { user: '', isAuthenticated: false },
  setState: () => {},
});

interface AppStateProviderProps {
  children: React.ReactNode;
}

export const AppStateProvider: React.FC<AppStateProviderProps> = ({ children }) => {
  const [state, setState] = useState<AppState>({ user: '', isAuthenticated: false });

  return (
    <AppStateContext.Provider value={{ state, setState }}>
      {children}
    </AppStateContext.Provider>
  );
};
